<template>
    <div class="app_banner" v-if="this.oneLink !== '' || this.appleLink !== '' || this.googleLink !== ''">
        <div class="row justify-content-center">
            <div class="col-4 app_banner_qr" v-if="this.oneLink !== ''">
                <div class="app_banner_qr-img">
                    <img :src="qrCode">
                </div>
                <div class="app_banner_qr-text">
                    Наведите камеру<br> на QR-код, чтобы скачать
                </div>
            </div>
            <div class="col-4 app_banner_desc">
                <div class="app_banner_desc-text">
                    Еще <b>больше функций</b> <br> в мобильном приложении
                </div>
                <div class="app_banner_desc-star">
                    <img src="../assets/img/star.png">
                </div>
                <div class="app_banner_desc-star">
                    <img src="../assets/img/star.png">
                </div>
                <div class="app_banner_desc-star">
                    <img src="../assets/img/star.png">
                </div>
            </div>
            <div class="col-4 app_banner_btn">
                <a :href="appleLink" target="_blank" v-if="this.appleLink !== ''">
                    <img src="../assets/img/app_store.png">
                </a>
                <a :href="googleLink" target="_blank" v-if="this.googleLink !== ''">
                    <img src="../assets/img/google_play.png">
                </a>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "AppBanner",
        computed: {
            appleLink(){
                return this.$store.getters.storeLinks.apple_store ?? ''
            },
            googleLink(){
                return this.$store.getters.storeLinks.google_play ?? ''
            },
            oneLink(){
                return this.$store.getters.storeLinks.onelink ?? ''
            },
            qrCode(){
                return 'https://chart.googleapis.com/chart?chs=50x50&cht=qr&chl='+encodeURI(this.oneLink)+'&choe=UTF-8&chld=L|0'
            }
        }
    }
</script>